import React from 'react'
import LoggedHeader from '../unit/LoggedHeader'
import './question.css'
import { Link, NavLink } from 'react-router-dom';
import ItemType from '../item/ItemType'
import {CheckedCorMBox, UnCheckedCorMBox} from '../unit/CorMBox'
import {OpenItem, CloseItem} from '../item/Item'

class QuestionManage extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {

        return (
            <div className="question">
                <LoggedHeader />
                <div className="question-article">
                    <div className="question-main">
                        <div className="question-left">
                            
                            
                            <Link to="questionCreate" className="none-text-decoration">
                                <UnCheckedCorMBox name="创建问卷"></UnCheckedCorMBox>
                            </Link>
                            <div className="question-left-aline"></div>
                            <CheckedCorMBox name="管理问卷"></CheckedCorMBox>
                        </div>
                        <div className="question-middle">

                        </div>
                        <div className="question-right">
                            <ItemType name="已开放问卷"></ItemType>
                            <div className="question-right-bottom">
                                <OpenItem name="关于第十周班会问卷" time="2020-4-13 8:30 至 2020-4-15 23:00"></OpenItem>
                                <OpenItem name="关于第十周班会问卷" time="2020-4-13 8:30 至 2020-4-15 23:00"></OpenItem>
                                <OpenItem name="关于第十周班会问卷" time="2020-4-13 8:30 至 2020-4-15 23:00"></OpenItem>
                            </div>
                            <div className="question-right-aline">
                            </div>
                            <ItemType name="未开放问卷"></ItemType>
                            <div className="question-right-bottom">
                                <CloseItem name="关于第十周班会问卷" time="2020-4-13 8:30 至 2020-4-15 23:00"></CloseItem>
                                <CloseItem name="关于第十周班会问卷" time="2020-4-13 8:30 至 2020-4-15 23:00"></CloseItem>
                                <CloseItem name="关于第十周班会问卷" time="2020-4-13 8:30 至 2020-4-15 23:00"></CloseItem>
                            </div>
                            <div className="question-right-aline">
                            </div>
                            {/* <img className="question-right-img" src={require("./question2.png")}></img> */}
                        </div>
                        <Link to="teacherHome">
                            <img className="question-back" src={require("../assert/back.png")}></img>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default QuestionManage;